// extracted by mini-css-extract-plugin
export default {"image":"AZ-z","loaded":"BZ-z"};